import {$, w} from './constants';

const initFaqCards = () => {
    const faqCards = $('[data-faq-card]');
    
    if (!faqCards.length) {
        return;
    }
    
    faqCards.each(function() {
        const card = $(this);
        const header = card.find('.faq-card-header');
        const content = card.find('.faq-card-content');
        
        if (!header.length || !content.length) {
            return;
        }
        
        // Initialize aria attributes
        const isExpanded = card.hasClass('is-expanded');
        header.attr('aria-expanded', isExpanded ? 'true' : 'false');
        content.attr('aria-hidden', isExpanded ? 'false' : 'true');
        
        if (isExpanded) {
            content.css('max-height', content[0].scrollHeight + 'px');
        }
        
        // Handle click on the entire header button
        header.on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const currentlyExpanded = header.attr('aria-expanded') === 'true';
            const newExpanded = !currentlyExpanded;
            
            // Update aria attributes
            header.attr('aria-expanded', newExpanded ? 'true' : 'false');
            content.attr('aria-hidden', newExpanded ? 'false' : 'true');
            
            // Toggle expanded class on card
            card.toggleClass('is-expanded', newExpanded);
            
            // Animate max-height
            if (newExpanded) {
                const scrollHeight = content[0].scrollHeight;
                content.css('max-height', scrollHeight + 'px');
            } else {
                content.css('max-height', '0');
            }
        });
    });
};

// Only initialize once on document ready
$(document).ready(() => {
    initFaqCards();
});

